export class CellNotFoundError extends Error {
  constructor(id: string) {
    super(`Cell not found: ${id}`);
    this.name = 'CellNotFoundError';
  }
}

export class WrongCellTypeError extends Error {
  constructor(id: string, expected: string) {
    super(`Cell ${id} is not a ${expected}`);
    this.name = 'WrongCellTypeError';
  }
}

export class InvalidCheckpointError extends Error {
  constructor(reason: string) {
    super(`Invalid checkpoint: ${reason}`);
    this.name = 'InvalidCheckpointError';
  }
}

export class InvalidTransferRowError extends Error {
  constructor(reason: string) {
    super(`Invalid transfer row: ${reason}`);
    this.name = 'InvalidTransferRowError';
  }
}

export class MissingTransferRowError extends Error {
  constructor(opId: string) {
    super(`TRANSFER operation ${opId} is missing transferRow.`);
    this.name = 'MissingTransferRowError';
  }
}

export class ArchetypeFieldMismatchError extends Error {
  constructor(reason: string) {
    super(`Archetype field mismatch: ${reason}`);
    this.name = 'ArchetypeFieldMismatchError';
  }
}

export class ContainerFieldMismatchError extends Error {
  constructor(reason: string) {
    super(`Container field mismatch: ${reason}`);
    this.name = 'ContainerFieldMismatchError';
  }
}

export class SnapshotError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SnapshotError';
  }
}

export class MissingComplexOptionsError extends Error {
  constructor(opId: string) {
    super(`COMPLEX operation ${opId} missing complexOptions.`);
    this.name = 'MissingComplexOptionsError';
  }
}
